module.exports = __webpack_public_path__ + "static/dashboardPerformance-58f59778055d82a3f3a91596415b2760.png";